import { toClassicIcon, userGroup } from "common/defaultIcons";
import { ROUTES } from "shared/constants";
import useHelpers from "composables/useHelpers.js";
import { myStudentsPortfolioFragment } from "portfolio/routes/fragments";
import { storeToRefs } from "pinia";
import { useModuleStore } from "store/modules/moduleStore.js";
import { myStudentsTransitionMeetingFragment } from "meetings/advisory/routes/fragments";
import { myStudentsStudentMeetingFragment } from "meetings/student-meeting/routes/fragments";

const { mappedTerms } = useHelpers();

const routes = () => [
  {
    name: "myStudents",
    path: "/my-students",
    redirect: () => {
      const moduleStore = useModuleStore();
      const { redirectToCorrectModule } = storeToRefs(moduleStore);
      return { name: redirectToCorrectModule.value.myStudentsRoute };
    },
    meta: {
      title: `Mijn ${mappedTerms.students}`,
      role: "teacher",
      // Verborgen uit het hoofdmenu (route blijft direct bereikbaar)
      isMenuItem: false,
      menuSection: "main",
      settingRequired: ["learningObjectives", "studentMeeting", "portfolio"],
      menuOrder: 4,
      icon: toClassicIcon(userGroup),
      roleRequired: [
        "webmaster",
        "manager",
        "organizer",
        "teamleader",
        "decaan",
        "teacher",
      ],
    },
    children: [
      ...myStudentsStudentMeetingFragment,
      ...myStudentsTransitionMeetingFragment,
      ...myStudentsPortfolioFragment,
      {
        path: "learning-objectives",
        name: "myStudentsLearningObjectives",
        component: () => import("pages/my-students/LearningObjectives.vue"),
        meta: {
          title: "Leerdoelen",
          sublabel: "bèta",

          isMenuItem: true,
          menuSection: "main",
          settingRequired: ["learningObjectives"],
          roleRequired: [
            "webmaster",
            "manager",
            "organizer",
            "teamleader",
            "decaan",
            "teacher",
          ],
        },
      },
    ],
  },
];

export default routes;
